import React, { useContext, useState, useRef, useEffect } from 'react';
import {
  Collapse,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './NavMenu.css';
import UserContext from '../providers/UserContext.js';
import { DealersClient, ProductsClient, SearchClient } from '../web-api-client.ts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faSearch } from '@fortawesome/free-solid-svg-icons';
import { isMobileDevice } from './utils/utils.js';
import ScannerLauncher from './ScannerLauncher.js';
import useToast from '../hooks/UseToast.js';
import { Modal, ModalBody, ModalHeader } from 'react-bootstrap';
import { useScannerSettings } from '../providers/ScannerSettingsContext.js';
import NewVehicle from './NewVehicle.js';
import Loader from './Loader.js';
import ManageBillingButton from './ManageBillingButton.tsx';


export function NavMenu(props) {
    const { pathname } = useLocation();

  const navigate = useNavigate();
  const user = useContext(UserContext);
  const location = useLocation();
  const { showToast } = useToast();
  const [state, setState] = useState({
    collapsed: true,
    searchTerm: ''
  });
  const [showScanner, setShowScanner] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [searchResults, setSearchResults] = useState({ products: [], jobs: [], items: [] });
  const [showNotFoundModal, setShowNotFoundModal] = useState(false);
  const [scannedBarcode, setScannedBarcode] = useState(null);
  const [enterPending, setEnterPending] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showAddVehicleModal, setShowAddVehicleModal] = useState(false);
  const [showNav, setShowNav] = useState(true);
  const [dealerInfo, setDealerInfo] = useState(null);



  const debounceRef = useRef(null);
  const searchContainerRef = useRef(null);
  const mobileSearchRef = useRef(null);
  const mobileSearchInputRef = useRef(null);
  const desktopSearchInputRef = useRef(null);
  const { scannerType } = useScannerSettings();

  const collapseNavbar = () => setState((prev) => ({ ...prev, collapsed: true }));


  const toggleNavbar = () => {
    setState((prev) => ({
      ...prev,
      collapsed: !prev.collapsed
    }));
  };
  const closeAddVehicleModal = () => {
    setShowAddVehicleModal(false);

  };
  const handleSearchSubmit = async (term = state.searchTerm, navigateOnResult = false) => {
    if (!term.trim()) {
      setSearchResults({ products: [], jobs: [], items: [] });
      setLoading(false);
      return;
    }

    setLoading(true); 

    try {
      const searchClient = new SearchClient();
      const searchData = await searchClient.globalSearch(term);
      setSearchResults(searchData);

      if (navigateOnResult) {
        const first =
          searchData.vehicles[0];

        if (first?.path) {
          navigate(`/${first.path}`);
          setDropdownVisible(false);
        }
      }
    } catch (error) {
      console.error('Error during search:', error);
      setSearchResults({ vehicles: [] });
    } finally {
      setLoading(false); // ⬅️ Done loading
    }
  };

  const handleSeachInput = (e) => {
    const newSearchTerm = e.target.value;
    search(newSearchTerm);
  }

  const search = (newTerm) => {
    setState((prev) => ({ ...prev, searchTerm: newTerm }));
    setDropdownVisible(newTerm.trim() !== '');

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    debounceRef.current = setTimeout(() => {
      handleSearchSubmit(newTerm); // pass the current value explicitly
    }, 300);
  }

  useEffect(() => {
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, []);
  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const hasResults =
    (searchResults.vehicles?.length > 0);

  useEffect(() => {
    setShowNav(!pathname.includes('/dvi/view') && !pathname.includes('/get-started'));

    async function fetchDealerInfo() {
      const client = new DealersClient();
      var info = await client.getDealerInfo(user ? user.dealerId : null);
      setDealerInfo(info);
    }
    fetchDealerInfo();

    function handleClickOutside(e) {
      if (
        searchContainerRef.current &&
        !searchContainerRef.current.contains(e.target) &&
        mobileSearchRef.current &&
        !mobileSearchRef.current.contains(e.target)
      ) {
        setDropdownVisible(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const handleFormSubmit = (e) => {
    e.preventDefault();
    handleSearchSubmit(state.searchTerm, true);
  };


 /*  const handleScan = async (barcode) => {
    setScannedBarcode(barcode);
    const client = new ProductsClient();
    const scanResults = await client.globalScan(barcode);
    if (scanResults && scanResults.type === 'NotFound') {
      setShowNotFoundModal(true);
      return;
    }
    if (scanResults && scanResults.path) {
      navigate(`/${scanResults.path}`);
    }
  }; */
  if (!showNav) return null;
  return (
    <header className='no-print'>
      <Navbar className="navbar-expand-md ng-white border-bottom box-shadow mb-3" container light>
        <NavbarBrand tag={Link} to="/dashboard" onClick={collapseNavbar} className="d-flex align-items-center" style={{ whiteSpace: 'nowrap' }}>
          <img
            className="logo"
            src="logo-light.png"
            alt="Logo"
            style={{ maxWidth: '200px', height: 'auto', objectFit: 'contain', marginRight: '10px' }}
          />
          
         
        </NavbarBrand>


        {/* Mobile Search Toggle Button */}
        <button
          className="btn btn-link d-md-none me-2"
          onClick={() => {
            setDropdownVisible((prev) => {
              const next = !prev;
              // Focus the input AFTER the search input renders
              if (next) {
                setTimeout(() => {
                  mobileSearchInputRef.current?.focus();
                }, 0);
              }
              return next;
            });
          }}
          aria-label="Search"
        >
          <FontAwesomeIcon icon={faSearch} />
        </button>
        <NavbarToggler onClick={toggleNavbar} className="mr-2" />

        <Collapse isOpen={!state.collapsed} navbar>
          <ul className="navbar-nav me-auto">
            <NavItem>
              <Link className="nav-link" to="/dashboard" onClick={collapseNavbar}>Dashboard</Link>
            </NavItem>
            <NavItem>
              <Link className="nav-link" to="/dvis" onClick={collapseNavbar}>Inspections</Link>
            </NavItem>
              <NavItem>
              <Link className="nav-link" to="/vehicles" onClick={collapseNavbar}>Vehicles</Link>
            </NavItem>
            <NavItem>
              <Link className="nav-link" to="/print-qrs" onClick={collapseNavbar}>Print QRs</Link>
            </NavItem>
           
          

            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
                Setup
              </DropdownToggle>
              <DropdownMenu end>
               {user && user.roles.includes('Dealer Admin') &&
               <DropdownItem tag={Link} to="/users" onClick={collapseNavbar}>Users</DropdownItem>
               }
                
                {user && user.isAdmin &&
                                <DropdownItem tag={Link} to="/admin" onClick={collapseNavbar}>Admin</DropdownItem>

                }
                 {user && user.roles.includes('Dealer Admin') &&
                <DropdownItem tag={Link} to="/inspection-items" onClick={collapseNavbar}>Inspection Items</DropdownItem>
               }
              
                <DropdownItem tag={Link} to="/settings" onClick={collapseNavbar}>Settings</DropdownItem>
              

              </DropdownMenu>
            </UncontrolledDropdown>
           
          </ul>

          {/* Desktop Only Search */}
          {/* <form
            ref={searchContainerRef}
            className="d-none d-md-flex me-3"
            onSubmit={handleFormSubmit}
            style={{ position: 'relative' }}
          >
            <div className="input-group" style={{ width: '400px' }}>
              <span className="input-group-text bg-dark border-secondary text-muted">
                <FontAwesomeIcon icon={faSearch} />
              </span>
              <input
                className="form-control bg-dark text-white border-secondary"
                type="search"
                placeholder="Search"
                aria-label="Search"
                value={state.searchTerm}
                onChange={handleSeachInput}
                ref={desktopSearchInputRef}
                onFocus={() => {
                  //select the input text when focused
                  desktopSearchInputRef.current?.select();
                  if (
                    state.searchTerm.trim() !== '' &&
                    (searchResults.vehicles.length > 0)
                  ) {
                    setDropdownVisible(true);
                  }
                }}
              />
            </div>

            {dropdownVisible && (
              <div className="search-dropdown">
                {loading ? (
                  <Loader />
                ) : (
                  <>
                    {(searchResults.vehicles.length > 0) ? (
                      <>
                        {searchResults.vehicles.length > 0 && (
                          <div className="mb-2">
                            <h6 className="px-3 pt-2 text-light">VEHICLES</h6>
                            <ul className="list-unstyled mb-2">
                              {searchResults.vehicles.map((vehicle, idx) => (
                                <li
                                  key={idx}
                                  className="px-4 py-3 border-bottom"
                                  style={{
                                    backgroundColor: '#2c2f33',
                                    transition: 'background-color 0.2s ease',
                                    width: '365px'
                                  }}
                                >
                                  <Link
                                    to={vehicle.path}
                                    className="d-block text-decoration-none"
                                    style={{ color: '#fff' }}
                                  >
                                    <div className="fw-semibold fs-6 mb-1">{vehicle.label || 'Unnamed Vehicle'}</div>
                                  
                                    <div className="text-muted small">
                                     &nbsp;
                                    </div>
                                 
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="text-muted px-3 py-2">No results found</div>
                    )}
                  </>
                )}
              </div>
            )}



          </form> */}
{dealerInfo && <>
          
          <img
            className="logo"
            src={dealerInfo?.logoUri}
            alt="Logo"
            style={{ maxWidth: '150px', height: 'auto', objectFit: 'contain', marginRight: '10px', maxHeight: '85px' }}
          />
          </>}
          <UncontrolledDropdown nav inNavbar>
            <DropdownToggle nav>
              <FontAwesomeIcon icon={faUser} />
            </DropdownToggle>
            <DropdownMenu end>
              <DropdownItem tag={Link} to="/account" onClick={collapseNavbar}>Profile</DropdownItem>
              <ManageBillingButton />
              <DropdownItem href="/Identity/Account/Logout" onClick={collapseNavbar}>Logout</DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Collapse>
      </Navbar>

      {/* Mobile Search (Outside Collapse, Always Shows if Toggled) */}
      {dropdownVisible && (
        <div
          ref={mobileSearchRef}
          className="d-md-none px-3 py-2 border-bottom"
          style={{ backgroundColor: '#1f1f1f' }}
        >
          <form onSubmit={handleFormSubmit}>
            <div className="d-flex align-items-center gap-2 mb-2">

              <input
                ref={mobileSearchInputRef}
                className="form-control mb-2 text-white mt-2"
                style={{
                  backgroundColor: '#2b2b2b',
                  borderColor: '#444',
                  borderRadius: '0.5rem'
                }}
                type="search"
                placeholder="Search"
                value={state.searchTerm}
                onChange={handleSeachInput}
                onFocus={() => {
                  //select the input text when focused
                  mobileSearchInputRef.current?.select();
                }}
              />
              <ScannerLauncher onBarcodeDetected={search} mode="button" buttonClasses="" />
            </div>

            <div
              className="rounded mt-2 p-2"
              style={{
                backgroundColor: '#2b2b2b',
                boxShadow: '0 2px 4px rgba(0,0,0,0.5)',
                border: '1px solid #444'
              }}
            >
              {loading ? (
                <Loader />
              ) : hasResults ? (
                <>
                  {searchResults.vehicles?.length > 0 && (
                    <>
                      <div className="text-muted small mb-2 border-bottom pb-1">Vehicles</div>
                      <ul className="list-group list-group-flush">
                        {searchResults.vehicles.map((vehicle, idx) => (
                          <li key={idx} className="list-group-item bg-transparent px-2 py-2 border-0">
                            <Link
                              onClick={() => setDropdownVisible(false)}
                              to={vehicle.path}
                              className="d-block text-light text-decoration-none px-2 py-1 rounded"
                              style={{ backgroundColor: '#2b2b2b' }}
                              onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#3a3a3a'}
                              onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#2b2b2b'}
                            >
                              <div className="fw-semibold">{vehicle.label}</div>
                              
                              <div className="text-muted small">
                               &nbsp;
                              </div>
                            
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </>
                  )}

                 
                 
                </>
              ) : (
                <div className="text-muted px-2">No results found</div>
              )}
            </div>
          </form>
        </div>
      )}



      {/* Mobile Scanner Button */}
      {/* {isMobileDevice() &&

        <ScannerLauncher onBarcodeDetected={handleScan} mode="floating" buttonClasses="" />

      } */}


      <Modal
        backdrop="static"
        show={showNotFoundModal}
        onHide={() => setShowNotFoundModal(false)}
        centered
      >
        <ModalHeader>Vehicle Not Found</ModalHeader>
        <ModalBody>
          <p>This vehicle was not found, create a new vehicle with this Vin: ({scannedBarcode})?</p>
          <div className="d-flex justify-content-end">
            <button className="btn btn-secondary me-2" onClick={() => setShowNotFoundModal(false)}>Cancel</button>
            <button className="btn btn-primary" onClick={() => { navigate(`/vehicles/newWithVin/${scannedBarcode}`); setShowNotFoundModal(false); }}>Create Vehicle</button>
          </div>
        </ModalBody>
      </Modal>
      <Modal show={showAddVehicleModal} onHide={closeAddVehicleModal} size="lg" scrollable centered backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Quick Add Vehicle</Modal.Title>
        </Modal.Header>
        <NewVehicle isQuickAdd={true} onComplete={closeAddVehicleModal} />
      </Modal>

    </header>
  );
}
